import React, { Component } from "react";
import "../projects.css";
import { Link } from "gatsby";
import report from "../images/report.svg";
import Parallax from "react-rellax";
class Project extends Component {
  constructor(props) {
    super(props);
    this.state = { bullets: this.props.bullets };
  }
  render() {
    const { blurb, name, videoLink, reportLink, bullets } = this.props;

    return (
      <div className="projectDiv">
        <iframe
          className="projectVid"
          width="660"
          height="450"
          src={videoLink}
        ></iframe>

        <div className="projectDesc">
          {/* <Parallax speed={10}> */}
          <div className="inLine">
            <Link to={reportLink} title="report here">
              <h3 className="projectName">{name}</h3>
            </Link>
            <Link to={reportLink}>
              <img title="report here" src={report} className="iconRight" />
            </Link>
          </div>
          {/* </Parallax> */}
          <p>{blurb}</p>
          <div>{bullets}</div>
        </div>
      </div>
    );
  }
}

export default Project;
